import type { Patient } from "../patients.types";

export function hasConditions(patient: Patient | null | undefined): boolean {
  return (
    (patient?.medicalHistory?.diseases?.length ?? 0) > 0 ||
    (patient?.medicalHistory?.surgeries?.length ?? 0) > 0 ||
    (patient?.fertilityHistory?.infertilityHistory?.causes?.length ?? 0) > 0
  );
}
